<div class="setting-page">
  <div class="alternative-sip-reason-group">
    <legend>Alternative Routing SIP Reasons</legend>
    <div class="alternative-sip-reason-group-container">
      <as-split direction="vertical">
        <as-split-area [minSize]="30" [size]="50">
          <div class="sip-reason-group-container">
            <div class="action-buttons">
              <arm-action-bar (addClick)="addSipReasonGroup()" [disableAdd]="isUnauthorized"
                              (refreshClick)="refresh()"
                              (deleteClick)="deleteSipReasonGroup()" [disableDelete]="isUnauthorized || !sipReasonGroup || (sipReasonGroup && sipReasonGroup.default)"
                              (editClick)="editSipReasonGroup()" [disableEdit]="isUnauthorized || !sipReasonGroup || (sipReasonGroup && sipReasonGroup.default)">
              </arm-action-bar>

              <button mat-raised-button class="more-actions" [matMenuTriggerFor]="menu" color="primary">
                <span>Actions</span>
                <mat-icon>arrow_drop_down</mat-icon>
              </button>

              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="duplicateSipReasonGroup()" [disabled]="isUnauthorized">
                  <span>Duplicate</span>
                </button>
              </mat-menu>
            </div>
            <div class="sip-reason-group-table">
              <arm-table [displayedColumns]="sipReasonGroupsDisplayedColumns"
                         (onSelection)="onSelectionSipReasonGroup($event)"
                         [data]="sipReasonGroups"
                         [isMultipleSelection]="false"
                         [isClientSide]="true"></arm-table>
            </div>
          </div>
        </as-split-area>

        <as-split-area [minSize]="30" [size]="50">
          <div class="sip-reasons-container">
            <div class="actions-sip-reason">
              <div class="search-container">
                <client-filter (onFilter)="onFilter($event)"></client-filter>
              </div>

              <div class="action-buttons">
                <arm-action-bar (addClick)="addSipReason()" [disableAdd]="isUnauthorized"
                                (deleteClick)="deleteSipReason()" [disableDelete]="isUnauthorized || !sipReasons || sipReasons.length === 0"
                                (editClick)="editSipReason()" [disableEdit]="isUnauthorized || (selectedSipReasons && selectedSipReasons.length > 1) || !sipReasons || sipReasons.length === 0">
                </arm-action-bar>
              </div>
            </div>

            <div class="sip-reason-table">
              <arm-table #sipReasonsTable [displayedColumns]="sipReasonDisplayedColumns"
                         (onSelection)="onSelectionSipReason($event)"
                         [data]="sipReasons"
                         [isMultipleSelection]="true"
                         [isClientSide]="true" [filter]="sipReasonsFilter"></arm-table>
            </div>
          </div>
        </as-split-area>
      </as-split>
    </div>
  </div>
</div>
